<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <!-- <th :class="StyleTh+' text-center'">#</th> -->
                <th :class="StyleTh">Folio</th>
                <th :class="StyleTh">Cliente</th>
                <th :class="StyleTh">Usuario</th>
                <th :class="StyleTh">Realizo</th>
                <th :class="StyleTh">Fecha</th>
                <th :class="StyleTh">Total</th>
                <th :class="StyleTh">EstatusPago</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>
            <template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                   <!-- <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td> -->
					<td><h6 :class="StylePr">{{lista.Folio}}</h6></td>
                    <td><p :class="StyleTd">{{lista.Cliente}}</p></td>
                    <td><p :class="StyleTd">{{lista.Nombre+' '+lista.Apellido}}</p></td>
                    <td><p :class="StyleTd">{{lista.NombrePago}}</p></td>
                    <td><p :class="StyleTd">{{ $getCleanDate(lista.Fecha, false, false)}}</p></td>
                    <td><p :class="StyleTd">{{ $formatNumber(lista.Total,'$')}}</p></td>
                    <td>
                        <span class="badge text-bg-info" v-if="lista.Estatus == 'Pendiente'">Pendiente</span>
                        <span class="badge text-bg-warning" v-if="lista.Estatus == 'Revision'">Revision</span>
                        <span class="badge text-bg-success" v-if="lista.Estatus == 'Pagado'">Pagado</span>
                        
                    </td>
                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="false" :pShowBtnDelete="false" :pIsModal="true" :pId="lista.IdPago" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">

                                <button class="btn btn-link text-danger px-3 mb-0 mr-1">
                                    <i class="far fa-file-pdf me-1 text-danger"></i> Ver Recibo
                                </button>

                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="8"></CSinRegistros>
			</template>
        </CList>
    </div>
</template>

<script>
import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionPagoRealizado';
export default {
     name: 'ListaPagoRealizado',
     props: ['sFiltros','pOrigen'],
     data() {
        return {
            ConfigList:{
                Title: 'Listado Pagos Realizados',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnNewShow: false,
                BtnReturnShow: false,
                TitleFirst: '',
                ShowTitleFirst:false
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
        async Lista(){
            await this.$http.get('pagos',{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                //this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('pagos/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
    },
    created() {
        his.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });
    }
}
</script>

<style>

</style>